import angular from 'angular';
import invoiceDetailsComponent from './invoice-details.component';
import costPlusInvoiceViewComponent from './views/cost-plus-invoice-view/cost-plus-invoice-view.component';

let invoiceDetailsModule = angular.module('invoiceDetails', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('costPlusInvoiceView', costPlusInvoiceViewComponent)
.component('invoiceDetails', invoiceDetailsComponent);


export default invoiceDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-details/invoice-details.js